import { ToastType } from './toast-type.enum';
import CircleCheckWhite from 'src/assets/images/icons/default/CircleCheckWhite';
import CircleExclamationWhite from 'src/assets/images/icons/default/CircleExclamationWhite';
import CircleInfoWhite from 'src/assets/images/icons/default/CircleInfoWhite';

/**
 * ToastStatusProps object that maps each ToastType to its respective properties.
 * Each type has its own border color, background color, and icon.
 */
export const ToastStatusProps: Record<
  ToastType,
  {
    borderColor: string;
    backgroundColor: string;
    icon: React.ReactNode;
  }
> = {
  /**
   * Properties for the Info toast type:
   * - borderColor: A light blue to represent info, using the custom variable.
   * - backgroundColor: A dark blue for the info toast background, using the custom variable.
   * - icon: An info icon to indicate success.
   */
  [ToastType.Info]: {
    borderColor: 'border-info-strong',
    backgroundColor: 'bg-info-inverse',
    icon: <CircleInfoWhite className="" />,
  },

  /**
   * Properties for the Success toast type:
   * - borderColor: A light green to represent success, using the custom variable.
   * - backgroundColor: A dark green for the success toast background, using the custom variable.
   * - icon: A checkmark icon to indicate success.
   */
  [ToastType.Success]: {
    borderColor: 'border-success-main',
    backgroundColor: 'bg-success-soft',
    icon: <CircleCheckWhite className="" />,
  },

  /**
   * Properties for the Error toast type:
   * - borderColor: A deep red to represent an error state, using the custom variable.
   * - backgroundColor: A dark maroon for the error toast background, using the custom variable.
   * - icon: An error exclamation icon to indicate failure or error.
   */
  [ToastType.Error]: {
    borderColor: 'border-error-primary-enabled',
    backgroundColor: 'bg-error-inverse-enabled',
    icon: <CircleExclamationWhite className="" />,
  },
};
